import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faLungs, faBed } from '@fortawesome/free-solid-svg-icons';


function SessionTypeFormatter(props) {
    const { sessionType } = props;
    switch (sessionType) {
        case "base":
            return (
                <>
                    <FontAwesomeIcon className="mdi" icon={faInfoCircle} />&nbsp;Base
                </>
            );
            break;
        case "breath":
            return (
                <>
                    <FontAwesomeIcon className="mdi" icon={faLungs} />&nbsp;Breathwork
                </>
            );
            break;
        case "sleep":
            return (
                <>
                    <FontAwesomeIcon className="mdi" icon={faBed} />&nbsp;Sleep
                </>
            );
            break;
        default:
            return (
                <>-</>
            );
            break;
    }

}

export default SessionTypeFormatter;
